import React, { useState } from "react";
import { Box } from "@material-ui/core";
import PageLayout from "layouts/PageLayout";
import useStyles from "./styles";
import TabsHeader from "./TabsHeader";
import TabPanel from "./TabPanel";
import useUserPermissions from "hooks/useUserPermissions";
import useDealerId from "hooks/useDealerId";
import withCardHidingStyles from "./withCardHidingStyles";

export default function EditStore(props) {
    const classes = useStyles();
    const [tabIndex, setTabIndex] = useState(0);
    const { permittedRoutes = [] } = useUserPermissions();
    const dealerId = useDealerId();

    const validTabs = permittedRoutes.filter((route) => typeof route.component === "function");

    return (
        <PageLayout showSelectDealer={false}>
            <Box>
                <div className={classes.root}>
                    <TabsHeader
                        tabIndex={tabIndex}
                        setTabIndex={setTabIndex}
                        tabLabels={validTabs.map((route) => route.name)}
                    />
                    {validTabs.map((route, index) => {
                        const Component = withCardHidingStyles(route.component);

                        return (
                            <TabPanel key={index} value={tabIndex} index={index}>
                                <Component showSelectDealer={false} dealerId={dealerId} />
                            </TabPanel>
                        );
                    })}
                </div>
            </Box>
        </PageLayout>
    );
}
